export const NewUpdates = [
  {
    id: 1,
    title: "1) Search Logic Update:",
    description:
      "Modify the search logic to pull records based on the first word. For example, if the Make is 'Chevrolet,'  Year is '2021,' and Model name is 'Silverado 3500,' the search should return all records of 'Silverado' for the 2021 Chevrolet make. Nexus will provide additional custom logic as necessary and inform us about models (such as hybrid models) to be excluded if required by the client.",
  },
  {
    id: 2,
    title: "2) Closest Match Dropdown:",
    description:
      " The dropdown should display all possible model options for the specified year and make. For example if the user selects Chevrolet as the Make and 2021 as the Year, the dropdown should show all available Silverado options for that year and make.",
  },
  {
    id: 3,
    title: "3) Handling Closest Match Before Current Fleet Details Upload:",
    description:
      " If the user does not select a 'closest match' option before adding to the Current Fleet Details, it should not be displayed after uploading the Current Fleet Details. Option to Deselect Closest Match: Provide users the ability to deselect a previously selected closest match before uploading the Current Fleet Details, as this option is currently unavailable.",
  },
  {
    id: 4,
    title: "4) Support Desk Page:",
    description:
      " A support desk page should be created where users can send queries,feedback, or upload images.",
  },
];
